module.exports = __webpack_public_path__ + "static/media/icono-jump.14013bc2.svg";